/**
 * Brand strings (docs/design/brand.md). One place; the disclaimer is shown on every exam surface (§16).
 * Exam names appear only nominatively — never their logos.
 */
export const BRAND = {
  company: 'English Language Training School',
  product: 'English Language Training School (ELTS)',
  productShort: 'ELTS',
  tagline: 'English exam preparation. Know your score before test day.',
  disclaimer:
    'English Language Training School (ELTS) is not affiliated with or endorsed by British Council, IDP, Cambridge University Press & Assessment, Pearson, or ETS. IELTS, PTE and TOEFL are trademarks of their respective owners.',
  /**
   * Icon only (cap and book), cut from the supplied logo so the name can be live text.
   * Static file in apps/web/public/brand/ — see that folder's README.
   */
  logo: '/brand/logo-mark.png',
} as const;
